import _actions_change_report from './_actions/change/report.js'
import _actions_open from './_actions/open.js'
import _actions_click from './_actions/click.js'
import _mutations_data from './_mutations/data.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        data: _mutations_data,
    },
    actions:{
        click: _actions_click,
        open: _actions_open,
        change_report: _actions_change_report,
    },
}